var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.75 84.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #039;\n      }\n\n      .cls-2 {\n        fill: #f9a418;\n      }\n\n      .cls-3 {\n        fill: #ffd662;\n      }\n\n      .cls-4 {\n        fill: #fff;\n        opacity: .3;\n      }\n\n      .cls-5 {\n        fill: #fde8a3;\n        opacity: .2;\n      }\n\n      .cls-6 {\n        fill: #f67e00;\n      }\n\n      .cls-7 {\n        fill: #00cc87;\n      }\n\n      .cls-8 {\n        fill: #e6e5e5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.1,44.69c0,3.44-2.78,6.22-6.22,6.22s-6.22-2.78-6.22-6.22,2.78-6.22,6.22-6.22,6.22,2.79,6.22,6.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.66 81.31 39.88 44.69 76.49 59.47 62.23 67.05 54.66 81.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.34,
    y: 62.12,
    width: 5.82,
    height: 23.89,
    transform: "translate(-32.09 70.65) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 28.68,
    y: 30.78,
    width: 2.06,
    height: 7.5,
    transform: "translate(-15.71 31.13) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 25.57,
    y: 35.44,
    width: 2.06,
    height: 7.5,
    transform: "translate(-19.78 48.8) rotate(-67.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 21.75,
    y: 43.66,
    width: 7.5,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 22.85,
    y: 49.17,
    width: 7.51,
    height: 2.06,
    transform: "translate(-17.19 14.01) rotate(-22.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 25.96,
    y: 53.83,
    width: 7.5,
    height: 2.06,
    transform: "translate(-30.11 37.16) rotate(-45.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 30.63,
    y: 56.95,
    width: 7.51,
    height: 2.06,
    transform: "translate(-32.34 67.55) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 38.85,
    y: 55.32,
    width: 2.06,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 50.5,
    y: 43.66,
    width: 7.5,
    height: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 49.41,
    y: 38.16,
    width: 7.51,
    height: 2.06,
    transform: "translate(-10.98 23.45) rotate(-22.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "48.12 37.91 46.66 36.45 51.97 31.14 53.42 32.6 48.12 37.91"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 41.63,
    y: 30.38,
    width: 7.51,
    height: 2.06,
    transform: "translate(-1.01 61.32) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 38.85,
    y: 26.57,
    width: 2.06,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 33.35,
    y: 27.66,
    width: 2.06,
    height: 7.5,
    transform: "translate(-9.39 15.51) rotate(-22.45)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.19,23.06c-3.7,5.57-11.22,7.09-16.8,3.38-.76-.51-1.45-1.08-2.05-1.72-.76-.8-1.4-1.68-1.91-2.63-.45-.84-.8-1.74-1.05-2.66-.07-.28-.14-.56-.19-.85-.24-1.25-.27-2.55-.11-3.83.03-.25.07-.5.12-.75.3-1.52.89-3,1.8-4.37.08-.12.17-.25.26-.37,3.78-5.27,11.09-6.64,16.54-3.02,1.34.89,2.45,2,3.3,3.25.17.24.32.49.47.74.64,1.1,1.1,2.29,1.36,3.52.06.27.11.54.15.82.14.98.17,1.97.07,2.96-.1,1.02-.33,2.04-.7,3.02-.27.72-.61,1.42-1.03,2.1-.08.13-.16.26-.24.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.46,20.58l-20.12,4.15c-.76-.8-1.4-1.68-1.91-2.63l22.73-4.54c-.1,1.02-.33,2.04-.7,3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.57,10.26l-22.49,4.5c.03-.25.07-.5.12-.75l21.9-4.5c.17.24.32.49.47.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.09,14.6l-23.7,4.84c-.07-.28-.14-.56-.19-.85l23.74-4.81c.06.27.11.54.15.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.16,21.72c-.08.12-.17.25-.25.36-3.04,4.15-8.85,5.21-13.17,2.34-4.32-2.87-5.59-8.64-2.94-13.05.08-.13.16-.25.24-.38,2.96-4.45,8.98-5.66,13.42-2.71,4.45,2.96,5.66,8.98,2.71,13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.91,22.08c-3.04,4.15-8.85,5.21-13.17,2.34-.1-.06-.19-.13-.28-.2-.94-.67-1.73-1.49-2.35-2.4-.62-.91-1.08-1.91-1.36-2.96-.07-.27-.13-.53-.18-.81-.22-1.24-.2-2.52.07-3.77.06-.3.14-.6.24-.89.22-.69.53-1.37.92-2.02,3.04-4.15,8.85-5.21,13.17-2.34.55.36,1.04.77,1.49,1.22.23.23.44.47.65.71.83,1.01,1.43,2.17,1.79,3.39.08.26.14.53.2.8.21,1.05.26,2.14.11,3.21-.14,1.05-.45,2.08-.94,3.07-.11.22-.23.43-.35.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.26,21.44l-13.81,2.78c-.94-.67-1.73-1.49-2.35-2.4l17.1-3.45c-.14,1.05-.45,2.08-.94,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.11,10.97l-16.47,3.32c.06-.3.14-.6.24-.89l15.58-3.14c.23.23.44.47.65.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.09,15.16l-18.34,3.7c-.07-.27-.13-.53-.18-.81l18.32-3.69c.08.26.14.53.2.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.45,15.74l-2.67-1.78c0,.51-.1,1.07-.34,1.65l2.15,1.43-1.02,1.54-2.13-1.42c-1.25,1.32-2.84,1.42-3.86,1.21-.28-.06-.55-.17-.79-.33l-1.08-.72,1.44,7.14-2.01-1.33-1.44-7.14,1.02-1.54,2.5,1.66c.81.54,1.85.51,2.6-.02l-4.06-2.7,1.02-1.54,4.06,2.7c.23-.91-.08-1.68-.28-2.06l-2.92-1.94,1.02-1.54,7.81,5.19-1.02,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.67,15.42l-2.67-1.78c0,.51-.1,1.07-.34,1.65l2.15,1.43-1.02,1.54-2.13-1.42c-1.25,1.32-2.84,1.42-3.86,1.21-.28-.06-.55-.17-.79-.33l-1.08-.72,1.44,7.14-2.01-1.33-1.44-7.14,1.02-1.54,2.5,1.66c.81.54,1.85.51,2.6-.02l-4.06-2.7,1.02-1.54,4.06,2.7c.23-.91-.08-1.68-.28-2.06l-2.92-1.94,1.02-1.54,7.81,5.19-1.02,1.54Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.84,6.54c1.87,5.16-.78,10.86-5.94,12.73-.7.26-1.42.43-2.13.52-.9.12-1.79.11-2.67-.02-.78-.11-1.54-.32-2.26-.6-.22-.09-.44-.18-.65-.29-.94-.46-1.81-1.06-2.58-1.79-.15-.14-.29-.29-.43-.44-.86-.93-1.55-2.05-2.01-3.31-.04-.12-.08-.23-.12-.35-1.64-5.06,1.02-10.55,6.06-12.38C23.35.15,24.62-.04,25.86,0c.24,0,.48.03.72.05,1.04.11,2.04.39,2.99.81.21.09.41.19.61.3.71.38,1.38.85,1.99,1.39.62.56,1.18,1.21,1.65,1.93.34.53.64,1.1.89,1.7.05.11.09.23.13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.82,4.5l-7.05,15.29c-.9.12-1.79.11-2.67-.02L32.16,2.57c.62.56,1.18,1.21,1.65,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.58.06l-7.97,17.03c-.15-.14-.29-.29-.43-.44L25.86,0c.24,0,.48.03.72.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.18,1.17l-8.34,18c-.22-.09-.44-.18-.65-.29L29.56.87c.21.09.41.19.61.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.96,7.22c.04.11.08.23.12.35,1.26,4.02-.87,8.38-4.87,9.83-4,1.45-8.42-.52-10.04-4.41-.05-.11-.09-.23-.13-.34-1.5-4.11.63-8.68,4.75-10.18,4.11-1.5,8.68.63,10.18,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.08,7.57c1.26,4.02-.87,8.38-4.87,9.83-.09.03-.18.06-.27.09-.9.29-1.82.41-2.73.38-.9-.03-1.79-.22-2.62-.55-.21-.08-.42-.17-.62-.27-.92-.46-1.76-1.09-2.45-1.88-.17-.19-.32-.39-.47-.59-.35-.48-.65-1.02-.89-1.59-1.26-4.02.87-8.38,4.87-9.83.51-.18,1.02-.31,1.53-.39.26-.04.52-.07.79-.08,1.07-.05,2.12.11,3.11.47.21.08.42.16.63.26.8.37,1.54.87,2.18,1.49.62.6,1.16,1.31,1.56,2.11.09.18.17.36.25.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.83,7.03l-4.88,10.46c-.9.29-1.82.41-2.73.38l6.05-12.96c.62.6,1.16,1.31,1.56,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.36,2.69l-5.82,12.48c-.17-.19-.32-.39-.47-.59l5.51-11.81c.26-.04.52-.07.79-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.09,3.42l-6.49,13.9c-.21-.08-.42-.17-.62-.27l6.48-13.89c.21.08.42.16.63.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.19,5.44l-2.47.9c.34.25.66.59.92,1.03l1.99-.72.52,1.42-1.97.72c.26,1.46-.45,2.56-1.08,3.13-.18.16-.38.28-.61.36l-1,.36,5.41,2.52-1.86.67-5.41-2.52-.52-1.42,2.32-.84c.75-.27,1.23-.97,1.26-1.73l-3.76,1.37-.52-1.42,3.76-1.37c-.49-.59-1.15-.77-1.49-.82l-2.7.98-.52-1.42,7.22-2.63.52,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.08,5.14l-2.47.9c.34.25.66.59.92,1.03l1.99-.72.52,1.42-1.97.72c.26,1.46-.45,2.56-1.08,3.13-.18.16-.38.28-.61.36l-1,.36,5.41,2.52-1.86.67-5.41-2.52-.52-1.42,2.32-.84c.75-.27,1.23-.97,1.26-1.73l-3.76,1.37-.52-1.42,3.76-1.37c-.49-.59-1.15-.77-1.49-.82l-2.7.98-.52-1.42,7.22-2.63.52,1.42Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.31,34.72c-.73,3.68-4.31,6.08-7.99,5.35-.5-.1-.98-.25-1.43-.45-.57-.25-1.09-.57-1.55-.96-.42-.34-.79-.73-1.11-1.16-.1-.13-.19-.26-.28-.4-.39-.6-.69-1.26-.87-1.96-.04-.14-.07-.27-.1-.41-.17-.85-.18-1.75,0-2.65.02-.08.03-.16.05-.25.84-3.54,4.33-5.81,7.93-5.1.89.18,1.7.52,2.41.98.14.09.27.19.4.28.57.43,1.06.95,1.46,1.53.09.13.17.26.25.39.28.48.51.99.67,1.52.17.55.26,1.13.28,1.72.01.43-.01.87-.08,1.31-.01.08-.03.17-.04.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.44,33.16l-9.55,6.45c-.57-.25-1.09-.57-1.55-.96l10.82-7.21c.17.55.26,1.13.28,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.77,28l-10.7,7.14c-.04-.14-.07-.27-.1-.41l10.4-7.01c.14.09.27.19.4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.48,29.92l-11.26,7.58c-.1-.13-.19-.26-.28-.4l11.29-7.57c.09.13.17.26.25.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.97,34.46c-.02.08-.03.16-.05.24-.69,2.8-3.47,4.6-6.33,4.03-2.86-.57-4.75-3.29-4.32-6.14.01-.08.03-.16.04-.25.58-2.94,3.45-4.86,6.39-4.27,2.94.58,4.86,3.45,4.27,6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.92,34.7c-.69,2.8-3.47,4.6-6.33,4.03-.06-.01-.13-.03-.19-.04-.63-.15-1.22-.4-1.73-.74-.52-.34-.97-.76-1.34-1.25-.09-.12-.18-.25-.27-.38-.38-.6-.64-1.26-.77-1.97-.03-.17-.05-.34-.07-.51-.03-.41-.02-.82.04-1.24.69-2.8,3.47-4.6,6.33-4.03.36.07.71.18,1.04.31.17.07.33.15.49.23.64.35,1.2.82,1.65,1.38.1.12.19.25.28.37.34.5.59,1.05.75,1.64.15.57.21,1.18.17,1.79,0,.13-.03.27-.05.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.96,34.29l-6.57,4.39c-.63-.15-1.22-.4-1.73-.74l8.13-5.44c.15.57.21,1.18.17,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.12,29.11l-7.83,5.24c-.03-.17-.05-.34-.07-.51l7.41-4.96c.17.07.33.15.49.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.05,30.86l-8.72,5.84c-.09-.12-.18-.25-.27-.38l8.71-5.83c.1.12.19.25.28.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.81,31.72l-1.77-.35c.11.27.18.58.18.93l1.42.28-.2,1.02-1.41-.28c-.37.95-1.17,1.34-1.74,1.45-.16.03-.32.03-.48,0l-.72-.14,2.27,3.39-1.33-.26-2.27-3.39.2-1.02,1.65.33c.54.11,1.07-.13,1.35-.57l-2.69-.53.2-1.02,2.68.53c-.07-.52-.4-.86-.58-1.01l-1.93-.38.2-1.02,5.16,1.02-.2,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.85,31.51l-1.77-.35c.11.27.18.58.18.93l1.42.28-.2,1.02-1.41-.28c-.37.95-1.17,1.34-1.74,1.45-.16.03-.32.03-.48,0l-.72-.14,2.27,3.39-1.33-.26-2.27-3.39.2-1.02,1.65.33c.54.11,1.07-.13,1.35-.57l-2.69-.53.2-1.02,2.68.53c-.07-.52-.4-.86-.58-1.01l-1.93-.38.2-1.02,5.16,1.02-.2,1.02Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.31,55.84c1.78,4.9-.74,10.31-5.64,12.1-.67.24-1.35.41-2.03.49-.85.11-1.7.1-2.53-.02-.74-.11-1.46-.3-2.15-.57-.21-.08-.42-.17-.62-.27-.9-.43-1.72-1.01-2.45-1.7-.14-.14-.28-.28-.41-.42-.81-.89-1.47-1.95-1.91-3.15-.04-.11-.08-.22-.11-.33-1.55-4.81.97-10.02,5.76-11.76,1.18-.43,2.39-.61,3.57-.56.23,0,.45.02.68.05.99.11,1.94.37,2.84.77.2.09.39.18.58.28.68.36,1.31.81,1.89,1.32.59.54,1.12,1.15,1.57,1.84.33.5.61,1.04.84,1.61.04.11.09.22.13.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.34,53.9l-6.7,14.53c-.85.11-1.7.1-2.53-.02l7.66-16.35c.59.54,1.12,1.15,1.57,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.46,49.68l-7.57,16.18c-.14-.14-.28-.28-.41-.42l7.31-15.81c.23,0,.45.02.68.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.88,50.74l-7.92,17.1c-.21-.08-.42-.17-.62-.27l7.96-17.11c.2.09.39.18.58.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.53,56.49c.04.11.08.22.11.33,1.2,3.82-.82,7.96-4.62,9.34-3.8,1.38-8-.49-9.54-4.19-.04-.11-.09-.21-.13-.32-1.42-3.91.6-8.25,4.51-9.67,3.91-1.42,8.25.6,9.67,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.64,56.82c1.2,3.82-.82,7.96-4.62,9.34-.09.03-.17.06-.26.09-.86.28-1.73.39-2.59.36-.86-.03-1.7-.21-2.49-.52-.2-.08-.4-.17-.59-.26-.88-.43-1.67-1.04-2.33-1.79-.16-.18-.31-.37-.45-.56-.33-.46-.62-.97-.84-1.51-1.2-3.82.82-7.96,4.62-9.34.48-.17.97-.3,1.46-.37.25-.04.5-.06.75-.07,1.02-.05,2.02.11,2.95.45.2.07.4.16.6.25.76.35,1.46.83,2.07,1.41.59.57,1.1,1.25,1.49,2.01.09.17.16.34.24.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.4,56.3l-4.64,9.94c-.86.28-1.73.39-2.59.36l5.75-12.31c.59.57,1.1,1.25,1.49,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M9.3,52.19l-5.53,11.86c-.16-.18-.31-.37-.45-.56l5.24-11.22c.25-.04.5-.06.75-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.85,52.88l-6.16,13.21c-.2-.08-.4-.17-.59-.26l6.16-13.19c.2.07.4.16.6.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.99,54.8l-2.35.85c.32.24.62.56.88.98l1.89-.69.49,1.35-1.87.68c.25,1.39-.42,2.44-1.03,2.98-.17.15-.36.26-.58.34l-.95.35,5.14,2.4-1.76.64-5.14-2.4-.49-1.35,2.2-.8c.71-.26,1.17-.92,1.19-1.64l-3.57,1.3-.49-1.35,3.57-1.3c-.46-.56-1.09-.73-1.42-.78l-2.57.93-.49-1.35,6.86-2.5.49,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.89,54.51l-2.35.85c.32.24.62.56.88.98l1.89-.69.49,1.35-1.87.68c.25,1.39-.42,2.44-1.03,2.98-.17.15-.36.26-.58.34l-.95.35,5.14,2.4-1.76.64-5.14-2.4-.49-1.35,2.2-.8c.71-.26,1.17-.92,1.19-1.64l-3.57,1.3-.49-1.35,3.57-1.3c-.46-.56-1.09-.73-1.42-.78l-2.57.93-.49-1.35,6.86-2.5.49,1.35Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/Apply.d923c334b36d309572d4b56ef26fe014.svg";
export { ForwardRef as ReactComponent };